export default __webpack_public_path__ + "static/media/video-no-text.56d01956.mp4";